<table
  data-test="Pjldhrn6"
  class="document__table items-table items-table_light"
  *ngIf="transports && transports.length"
>
  <tr data-test="aNHqkB45" class="items-table__header items-table__header_fs-9">
    <th data-test="f4kZmyJs">Transport name</th>
    <th data-test="_MGXr0mB">Calculation</th>
    <th data-test="Lou3Wrj6" class="text-right pr-2">Amount</th>
  </tr>
  <tr
    data-test="EjTIl6NA"
    class="row-type"
    *ngFor="let transport of transports; index as i"
  >
    <td data-test="qh7Zx2Fk">
      <b data-test="-R4ULvsn">{{ transport.name }}</b>
      <ng-container *ngIf="transport.group">- {{ transport.group }}</ng-container>
      <div data-test="Q-TBaK5Q" class="text-xsmall">{{ transport.code }}</div>
    </td>
    <td data-test="DeQ1ZakD" style="padding: 10px">
      <table data-test="AbJUNoMt" class="transport-calculation">
        <tr data-test="S9YDOcql">
          <td data-test="F3Cs9Pwi" class="text-right">
            <b data-test="iuoDVw6c">Rental =</b>
          </td>
          <td data-test="z6iJatTM" class="text-right">{{ transport.qty }}</td>
          <td data-test="BEXQLYnt">vehicle(s)</td>
          <td data-test="duMBAPi6" class="text-right">
            <span data-test="ORkklbxi" class="text-light">{{ currencySign }}</span>
            {{ transport.costBillablePrice | fromCents | companyCurrency }}
          </td>
          <td data-test="f2DaLWAw">&nbsp;per day</td>
        </tr>
        <tr data-test="URhtHkWC">
          <td data-test="CN4x4Fzk" class="text-right">
            <b data-test="_Og3m9Rt">Kilometers (forfait) =</b>
          </td>
          <td data-test="yAi3fXFM" class="text-right">
            {{ transport.distance / 1000 }}
          </td>
          <td data-test="vJ3A_XN6">kilometers</td>
          <td data-test="lFHvKxgG" class="text-right">
            <span data-test="1A9KcasC" class="text-light">{{ currencySign }}</span>
            {{ transport.distanceBillablePrice | fromCents | companyCurrency }}
          </td>
          <td data-test="2ENZEJz9">&nbsp;per day</td>
        </tr>
        <tr data-test="AfrLtMJa">
          <td data-test="IQN4INk8" class="text-right"></td>
          <td data-test="Vy-bXrbV" class="text-right"></td>
          <td data-test="W7l5udRI"></td>
          <td data-test="xseAUNNe" class="text-right">
            <span data-test="DopOMfR5" class="text-light">{{ currencySign }}</span>
            {{ transport.handlingBillablePrice | fromCents | companyCurrency }}
          </td>
          <td data-test="UIjyukB9">&nbsp;handling</td>
        </tr>
      </table>
    </td>
    <td data-test="uDmzSeCF" class="text-right pr-2">
      <b data-test="M4E9-Nkq">
        <span data-test="T_UbU_wL" class="text-light">{{ currencySign }}</span>
        {{ getTransportBillableRowTotal(transport) | fromCents | companyCurrency }}
      </b>
    </td>
  </tr>
</table>
